import React, { useState, useEffect, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import MatTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import {
  schoolClassListByFilterQuery,
  classRemoveMutation,
} from '../../shared/queries/SchoolClass';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import SchoolClassFilter from './components/SchoolClassFilter';
import listCoursesWithStepsByFilter from '../../shared/queries/Course';
import { employeeTeamClassBySchoolClassId } from '../../shared/queries/RelationEmployeeClass';

const SchoolClass = (props) => {
  const { t, dispatch, history } = props;
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [lastFilter, setLastFilter] = useState({
    studentsQuantity: 0,
    updaterId: 0,
    year: 0,
    id: 0,
    capacity: 0,
    filterByStatus: true,
    active: true,
  });

  const [courses, setCourses] = useState([]);
  const [team, setTeam] = useState([]);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadCourses = () => {
    showLoading();
    const filter = {
      id: 0,
    };
    const query = listCoursesWithStepsByFilter(filter);
    GraphQL(query, {})
      .then((res) => {
        if (res.courseListByFilter) {
          const coursesReduced = res.courseListByFilter.reduce(
            (acc, course) => acc.concat(course.steps),
            []
          );
          setCourses(coursesReduced);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadTeam = () => {
    showLoading();
    const query = employeeTeamClassBySchoolClassId();
    GraphQL(query, {})
      .then((res) => {
        if (res.relationEmployeeClassBySchoolClassId) {
          const teamReduced = res.relationEmployeeClassBySchoolClassId.reduce(
            (acc, item) => {
              return acc.concat(item.employee);
            },
            []
          );
          setTeam(teamReduced);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadSchoolClass = (filter) => {
    showLoading();
    const dataQuery = schoolClassListByFilterQuery(filter);
    GraphQL(dataQuery, {})
      .then((res) => {
        hideLoading();
        res.classList = res.classListByFilter.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
          availability: item.capacity - item.studentsQuantity,
        }));
        setData(res.classList);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push(`/minime/turma/mnt/0`);
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    history.push(`/minime/turma/mnt/${rowData.id}`);
  };

  const removeItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeQuery = classRemoveMutation(selectedDto.id);
    GraphQL(removeQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        hideLoading();
      });
  };

  const onFilterClickHandler = (filter) => {
    if (filterIsOpen) {
      onFilterToggle();
    }
    if (filter) {
      setLastFilter(filter);
      loadSchoolClass(filter);
    } else if (lastFilter) {
      loadSchoolClass(lastFilter);
    }
  };

  const filterBuildFunction = () => (
    <SchoolClassFilter
      filterClick={onFilterClickHandler}
      lastFilter={lastFilter}
      courses={courses}
      team={team}
    />
  );

  useEffect(() => {
    loadCourses();
    loadTeam();
    onFilterClickHandler();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    filterBuildFunction={filterBuildFunction}
                    isFiltering={filterIsOpen}
                    filterToggle={onFilterToggle}
                    onRefreshClick={onFilterClickHandler}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    title={t('panels.turma')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

SchoolClass.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SchoolClass)
);
